<template>
  <!-- 教师团队 -->
  <div class="teacher-list">
    <!-- <div class="section-title">
      <i class="el-icon-s-custom"></i>
      <span>教师团队</span>
    </div>-->
    <div class="teacher-grid-container">
      <div class="teacher-grid" v-if="teachers && teachers.length > 0">
        <div
          :class="['teacher-card', { 'leader_1': item.is_leading == 1 || item.is_leading == '1', 'leader_2': item.is_leading == 0 || item.is_leading == '0' }]"
          v-for="(item, index) in teachers" :key="index">
          <div class="avatar-card">
            <div class="avatar-img" v-if="item.is_leading == 1 || item.is_leading == '1'">
              <!--负责人 -->
              <el-image :src="userAvatar" fit="cover"></el-image>
            </div>
            <div class="leader-tag">
              <span class="icon-leader">{{ item.is_leading == 1 || item.is_leading == "1" ? "负责人" : "" }}</span>
            </div>
          </div>
          <div class="avatar">
            <div class="avatar-bg">
              <el-image :src="item.avatar || defaultAvatar" fit="cover">
                <div slot="error" class="error-avatar">
                  <i class="el-icon-user-solid"></i>
                </div>
              </el-image>
            </div>
            <div class="name">
              {{ item.name }}
              <div class="duty">{{ item.college_name }}</div>
            </div>
          </div>
          <div class="info">
            <div class="intro" v-if="item.intro">
              <span class="intro-text" v-html="item.intro"></span>
            </div>
            <div class="intro" v-else>暂无相关简介</div>
          </div>
        </div>
      </div>
      <div class="empty" v-else>
        <div class="is-empty" style="text-align: center">
          <img :src="no_math" />
          <div style="
            font-size: 18px;
            color: #b5a2a2;
            margin-bottom: 30px;
            text-align: center;
          ">
            <span>暂无教师信息</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "teacherlist",
  props: {
    teachers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      defaultAvatar: require("@/assets/course/UIout/teachteam/teachteam_ico_avatar.png"),
      userAvatar: require("@/assets/course/UIout/teachteam/teachteam_badge_leader.png"),
      no_math: require("@/assets/no_math1.png"), // 没有公式
    }
  },
  methods: {
    initdata(obj) {
      // 预留初始化方法，兼容父组件调用
      console.log("教师团队 initdata", obj)
    },
  },
}
</script>

<style lang="scss" scoped>
.teacher-list {

  background: #FFFFFF;
  box-shadow: 0px 2px 8px 0px rgba(128, 112, 250, 0.1);
  border-radius: 12px 12px 12px 12px;

  .section-title {
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: #222222;
    margin-bottom: 16px;

    i {
      margin-right: 8px;
      color: #7b5cff;
      font-size: 20px;
    }
  }

  .teacher-grid-container {
    background: url(~@/assets/course/UIout/teachteam/teachteam_decor_01.png) no-repeat;
    background-position: right bottom;
    min-height: 400px;
    padding: 16px;

    .teacher-grid {

      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 10px;
      width: 100%;

      .teacher-card {
        // display: flex;
        // align-items: center;
        // padding: 0px 16px 16px 16px;
        // background: #f8f9fe;
        border-radius: 12px;
        transition: all 0.3s;
        position: relative;
        // box-shadow: 0px 2px 10px 0px rgba(128, 112, 250, 0.19);
        // border-radius: 12px 12px 12px 12px;
        // border: 1px solid;
        // border-image: linear-gradient(180deg, rgba(128, 112, 250, 0.15), rgba(255, 255, 255, 1)) 1 1;
        width: 100%;

        &.leader_1 {
          background: url(~@/assets/course/UIout/teachteam/teachteam_cardbg_01.png) no-repeat center center;
          background-size: 100% 100%;
          min-height: 450px;
        }

        &.leader_2 {
          background: url(~@/assets/course/UIout/teachteam/teachteam_cardbg_03.png) no-repeat center center;
          background-size: 100% 100%;
          min-height: 450px;
        }

        .avatar-card {
          // padding-bottom: 20px;

          .avatar-img {
            position: absolute;
            right: 9px;
            top: 8px;
          }

          .leader-tag {
            position: absolute;
            right: 20px;
            top: 12px;
            font-weight: bold;
            font-size: 16px;
            color: #ffffff;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }

        &:hover {
          box-shadow: 0 4px 16px rgba(123, 92, 255, 0.12);
          transform: translateY(-2px);
        }

        .avatar {
          display: flex;
          align-items: center;
          padding: 16px;

          .avatar-bg {
            width: 64px;
            height: 64px;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 14px;
            flex-shrink: 0;

            ::v-deep .el-image {
              width: 100%;
              height: 100%;
            }
          }

          .error-avatar {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #7b5cff;
            font-size: 28px;
          }

          .name {
            font-weight: bold;
            font-size: 18px;
            color: #333333;
            text-align: left;
            font-style: normal;
            text-transform: none;

            .duty {
              font-weight: bold;
              font-size: 16px;
              color: #555555;
              text-align: left;
              font-style: normal;
              text-transform: none;
            }
          }
        }

        .info {
          .duty {
            font-size: 13px;
            color: #7b5cff;
            margin-bottom: 6px;
          }

          .intro {
            margin: 0px 30px 30px;
            // font-weight: bold;
            font-size: 16px;
            color: #555555;
            line-height: 24px;
            text-align: justified;
            font-style: normal;
            text-transform: none;

            // margin-top: 20px;
            // overflow: hidden;
            // text-overflow: ellipsis;
            // display: -webkit-box;
            // -webkit-line-clamp: 5;
            // line-clamp: 5;
            // -webkit-box-orient: vertical;
            .intro-text {
              cursor: default;
            }
          }
        }
      }
    }
  }


  .empty {
    text-align: center;
    padding: 60px 0;
    color: #999999;
    font-size: 14px;
  }
}

/* 响应式 */
@media screen and (max-width: 1200px) {
  .teacher-list {
    .teacher-grid-container {
      .teacher-grid {
        grid-template-columns: repeat(3, 1fr);
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .teacher-list {
    .teacher-grid-container {
      padding: 12px;
      min-height: auto;

      .teacher-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;

        .teacher-card {
          .avatar {
            padding: 12px;

            .avatar-bg {
              width: 48px;
              height: 48px;
              margin-right: 10px;
            }

            .name {
              font-size: 16px;

              .duty {
                font-size: 14px;
              }
            }
          }

          .info {
            .intro {
              margin: 0 16px 16px;
              font-size: 14px;
              line-height: 22px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .teacher-list {
    .teacher-grid-container {
      padding: 10px;

      .teacher-grid {
        grid-template-columns: 1fr;
        gap: 10px;

        .teacher-card {
          .avatar {
            padding: 10px;

            .avatar-bg {
              width: 40px;
              height: 40px;
              margin-right: 8px;
            }

            .name {
              font-size: 14px;

              .duty {
                font-size: 12px;
              }
            }
          }

          .info {
            .intro {
              margin: 0 12px 12px;
              font-size: 13px;
              line-height: 20px;
            }
          }
        }
      }
    }
  }
}
</style>
